import JobDto from '../job/job-dto';
import UserDto from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/user-dto';

export default class CalendarJobDto
{
    public id: number|null = null;
    public user: UserDto|null = null;
    public job: JobDto|null = null;
    public dateFrom = '';
    public dateTo = '';
    public dateCreated = '';
    public dateUpdated = '';
}